













































































import {Component, Vue} from "vue-property-decorator";
import {delNullProperty} from "@/utils/index";
import axios from "axios";
import {Loading} from "element-ui";
import clue_select from './clue_select.vue';
import vantSelect from './vant-newselect.vue'

@Component({
  name: "AppLicationForm",
  components: {clueSelect: clue_select, vantSelect}
})
export default class extends Vue {
  private show = false;
  private gradeShow = false;  //年级
  private directionShow = false;  //咨询专业方向
  private grade = "";
  private gradeList = [
    {label: 'Grade 7', value: '美制7年级/英制8年级/初一（普高）'},
    {label: 'Grade 8', value: '美制8年级/英制9年级/初二（普高）'},
    {label: 'Grade 9', value: '美制9年级/英制10年级/初三（普高）'},
    {label: 'Grade 10', value: '美制10年级/英制11年级/高一（普高）'},
    {label: 'Grade 11', value: '美制11年级/英制12年级/高二（普高）'},
    {label: 'Grade 12', value: '美制12年级/英制13年级/高三（普高）'},
    {label: 'Freshmen', value: '大学一年级'},
    {label: 'Sophmore', value: '大学二年级'},
    {label: 'Junior', value: '大学三年级'},
    {label: 'Senior', value: '大学四年级'},
    {label: 'Graduate Student', value: '研究生及以上'},
    {label: 'Graduated', value: '已毕业'}
  ];
  private marketName = "";
  private phone = "";
  private weChat = "";
  private email = "";
  private remark = "";
  // private direction = "";
  private gradeVal = "";
  private specialized = "";
  private errorInfos = {
    // 存放对应输入框的报错信息，在提交的时候统一验证
    name: "",
    phone: "",
    weChat: "",
    email: "",
    grade: "",
    specialized: "",
    attendSchool: ""
  };

  private schoolShow = false;
  private attendSchool = '';
  private schoolList = [];
  private schoolId = '';
  private schoolName = null;
  private page = 1;
  private directorUserId = "";
  private from: "market" | "customer" = "market";
  private axios = null;
  private resultSuccess = false; // 提交成功
  private resultError = false

  created() {
    const query = this.$route.query;
    this.directorUserId = query.userId as string;
    // this.from = query.from as "market" | "customer";
    this.createAxios();
  }

  mounted() {
    this.setDocumentFontSize();
    window.addEventListener("resize", this.setDocumentFontSize);
  }

  createAxios() {
    const origin = location.hostname; //当前访问域名
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_API;
      }
    }
    const config = {
      baseURL: requestBase,
      timeout: 30 * 1000, // Timeout
    };

    this.axios = axios.create(config);
  }

  destroyed() {
    document.documentElement.style.fontSize = "16px";
  }



  showPopup() {
    this.schoolShow = true
  }

  handleSchool(data) {
    this.schoolList = data
  }

  listenSchool(data) {
    if (data != false) {
      this.schoolId = data.id
      this.attendSchool = data.text
    }

    this.schoolShow = false
  }



  gradeShowPopup() { //年级
    this.gradeShow = true
  }

  // 年级
  listenGrade(data) {
    if (data) {
      this.grade = data.label
      this.gradeVal = data.value
    }
    this.gradeShow = false
  }

  directionShowPopup() { //咨询专业方向
    this.directionShow = true
  }




  submitForm() {
    let isComplete = true;
    /* 清空报错信息 */
    for (const key in this.errorInfos) {
      this.errorInfos[key] = "";
    }
    /* 非空验证 */
    if (this.checkNull(this.marketName)) {
      this.errorInfos.name = "Please input Full Name";
      isComplete = false;
    }
    if (this.checkNull(this.phone)) {
      this.errorInfos.phone = "Please input Phone No.";
      isComplete = false;
    }
    if (this.checkNull(this.weChat)) {
      this.errorInfos.weChat = "Please input WeChat No.";
      isComplete = false;
    }

    if (this.checkNull(this.grade)) {
      this.errorInfos.grade = "Please input Grade";
      isComplete = false;
    }
    if (this.attendSchool.length == 0) {
      this.errorInfos.attendSchool = "Please input School";
      isComplete = false;
    }

    if (this.checkNull(this.email)) {
      this.errorInfos.email = "Please input Email Address ";
      isComplete = false;
    }

    if (this.checkNull(this.specialized)) {
      this.errorInfos.specialized = "Please input Targeted Major";
      isComplete = false;
    }

    if (isComplete) {
      // if (this.from === "customer") {
      this.setMarketClueByQrcode();
      // }
    }
  }

  checkNull(value: string | number): boolean {
    return ["", null, undefined, NaN].includes(value);
  }

  // 提交市场线索
  async setMarketClueByQrcode() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.axios
        .post(
            "/customer/setCustomerBusinessByShzxgjb",
            delNullProperty({
              name: this.marketName,
              phone: this.phone,
              weChat: this.weChat,
              email: this.email,
              grade: this.gradeVal,
              school: this.attendSchool,
              specialized: this.specialized,
            })
        )
        .then(({data}) => {
          // 判断错误状态
          const error = data.error;
          if (error.returnCode === 1) {
            this.errorInfos.name = error.returnMessage;
          }
          if (error.returnCode === 0) {
            this.resultSuccess = true;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.resultError = true
        });
  }

  closePage() {
    window.open("about:blank", "_self").close();
  }

  // 设置跟元素字体大小
  private setDocumentFontSize() {
    document.documentElement.style.fontSize =
        document.documentElement.getBoundingClientRect().width / 7.5 + "px";
  }
}
